import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { ErrorMessage, SuccessMessage,RodapeImpressao } from './UtilComponent';


class ContainerDefault extends Component {

    render() {
        return (
            // fluid
            <Container style={{paddingLeft:'3rem', paddingRight:'3rem'}}  fluid className=" text-md-left ">
                <Row className="mt-3 noprint">
                    <Col>
                        <h3>{this.props.title}</h3>
                    </Col>
                </Row>
                <hr class='noprint'/>
                {
                    typeof this.props.messageSuccess !== 'undefined' && this.props.messageSuccess !== null ?

                        <SuccessMessage key='successMessage' successMessage={this.props.messageSuccess} />

                        : <Row></Row>
                }
                {
                    typeof this.props.messages !== 'undefined' && (this.props.messages !== null || this.props.messages.length > 0) ?

                        <ErrorMessage key='errorMessage' error={this.props.messages} />

                        : <Row></Row>
                }
                {!this.props.url ? <></> :
                    <Row className="mt-3">
                        <Col>
                            <ButtonGroup>
                                <Button
                                    href={this.props.url}
                                >
                                    <i className="fa fa-plus" aria-hidden="true" /> {this.props.button}
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                }
                <Row style={{marginTop:'2rem'}}>
                    <Col>
                        {this.props.container}
                    </Col>
                </Row>
                <RodapeImpressao/>

            </Container>
        );
    }
}

export default ContainerDefault;